import { useEffect, useMemo, useState } from 'react'
import styled from 'styled-components'
import useDataFetcher from '../../../main/second/mainbar/knisot/hooks/useFetchData'
import { IPalletLogItem } from '../../../modules/API/Pallets/models/palletLog'
import { Pallets } from '../../../modules/API/Pallets/pallets'
import { Defaults } from '../../../modules/API/Defaults/defaults'
import { IWorkerItem, IWorkerItemResponse } from '../../../modules/API/Defaults/models/workers'
import ErrorPalletLog from './Components/ErrorPalletLog'
import CustomBlockLoader from '../../../main/second/mainbar/knisot/generic/CustomBlockLoader'
import EmptyMessage from './Components/EmptyMessage'
import PalletLogItem from './Components/PalletLogItem'
import ControlSearchPannelLayout from '../../Layouts/Wrappers/ControlSearchPannelLayout'
import SearchInput from '../../inputs/inputSearch'
import BodyScrollContainer from '../../Layouts/Wrappers/BodyScrollContainer'

type Props = {
  teudaNum: number
  teudaSub: number
  orderNum: number
}

const PalletLogModal = ({ teudaNum, teudaSub, orderNum }: Props) => {
  const [search, setSearch] = useState('')
  const [workerMap, setWorkerMap] = useState<Map<number, string>>(new Map())

  const { data, isLoading, error } = useDataFetcher<IPalletLogItem[]>(
    Pallets.getPalletsLogByTeudaOrOrder,
    `Delivery_Num=${teudaNum}&Delivery_Sub=${teudaSub}&OrderID=${orderNum}`,
  )

  useEffect(() => {
    Defaults.getWorkers('').then((res: IWorkerItemResponse) => {
      const map = new Map<number, string>()
      res.workers?.forEach((w: IWorkerItem) => {
        map.set(w.WorkerId, w.WorkerName)
      })
      setWorkerMap(map)
    })
  }, [])

  const renderList = useMemo(() => {
    if (!data) return []
    const q = search.trim().toLowerCase()
    if (!q) return data
    return data.filter((item) =>
      `${item.ProductDesc.trim()} ${item.VarietyDesc.trim()} ${item.SizeID.trim()}`
        .toLowerCase()
        .includes(q)
    )
  }, [data, search])

  if (error) return <ErrorPalletLog />

  return (
    <MainWrapper>
      {isLoading ? (
        <CustomBlockLoader />
      ) : renderList.length === 0 ? (
        <EmptyMessage />
      ) : (
        <>
          <ControlSearchPannelLayout>
            <SearchInput
              input={search}
              setInput={setSearch}
            />
          </ControlSearchPannelLayout>
          <BodyWrapper>
            {renderList.map((item) => (
              <PalletLogItem
                key={item.Time}
                {...item}
                workerName={workerMap.get(item.WorkerID)}
              />
            ))}
          </BodyWrapper>
        </>
      )}
    </MainWrapper>
  )
}

const MainWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5em;
  overflow-y: hidden;
`
const BodyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5em;
  overflow-y: auto;

  padding:0 0.5em;
  &::-webkit-scrollbar {
    width: 0;
  }
`
export default PalletLogModal
